import { Component, Inject, Input, OnInit, forwardRef } from '@angular/core';
import { NgbActiveModal }  from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { MessagesService }      from '../messages/messages.service';
import { SessionCompanyModel }  from '../sessions/models/session.company';
import { TableRowEvent }        from '../table/types/table-row-event';
import { VendorFactoryService } from './vendor-factory.service';
import { VendorModel }          from './models/vendor';

@Component({
  selector: 'wor-vendor-manually-link',
  template: `
    <div class="modal-header state clearfix bg-info title">
      <h1>Matching Vendors</h1>
    </div>
    <div class="modal-body clearfix">
      <div class="row text-left">
        <div class="col-sm-3 form-group">
          <label for="search_type" class="control-label">Type</label>
          <select class="form-control" id="search_type" name="search_type"
            [(ngModel)]="filters.search_type">
            <option *ngFor="let type of searchTypes" [value]="type.code">{{ type.description }}</option>
          </select>
        </div>
        <div class="col-sm-4 form-group">
          <label for="search_term" class="control-label">Search</label>
          <div class="input-group">
            <input type="text" class="form-control" name="search_term" id="search_term"
              [(ngModel)]="filters.search_term"
              (keydown.enter)="filter()" />
            <span class="input-group-btn">
              <button class="btn btn-info btn-addon" type="button" (click)="filter()">
                Apply
              </button>
            </span>
          </div>
        </div>
      </div>
      <wor-table
        [(data)]="vendors"
        [settings]="tableSettings"
        (rowClick)="onRowClick()"
        (rowDoubleClick)="onRowDoubleClick($event)">
      </wor-table>
    </div>
    <div class="modal-footer d-flex">
      <button type="button" class="btn btn-danger m-left-auto"
        (click)="modal.dismiss()">
        Cancel
      </button>
      <button type="button" class="btn btn-success"
        [disabled]="!selectedItems.length"
        (click)="confirm()">
        Confirm
      </button>
    </div>
  `
})
export class VendorManuallyLinkComponent implements OnInit {
  @Input() company: SessionCompanyModel;

  vendors: VendorModel[] = [];
  selectedItems: VendorModel[] = [];
  tableSettings: Record<string, unknown>;

  filters = {
    search_term: '',
    search_type: 'starts_with'
  };

  searchTypes = [
    { code: 'starts_with', description: 'Starts With' },
    { code: 'contains', description: 'Contains' }
  ];

  constructor (
    public  modal               : NgbActiveModal,
    private messagesService     : MessagesService,
    private translateService    : TranslateService,
    @Inject(forwardRef(() => VendorFactoryService)) private vendorFactoryService: VendorFactoryService
  ) {}

  ngOnInit (): void {
    this.tableSettings = {
      columns: [
        {
          field : 'company_name',
          header: {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.NAME')
          }
        },
        {
          field : 'phone',
          header: {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.PHONE')
          },
          pipe: 'phone'
        },
        {
          field : 'mobile',
          header: {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.MOBILE')
          },
          pipe: 'mobilePhone'
        },
        {
          field : 'email',
          header: {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.EMAIL')
          }
        },
        {
          field : 'address1',
          header: {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.ADDRESS')
          }
        },
        {
          field : 'address2',
          header: {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.ADDRESS')
          }
        },
        {
          field : 'suburb',
          header: {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.SUBURB')
          }
        },
        {
          field : 'state',
          header: {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.STATE')
          }
        },
        {
          field : 'postcode',
          header: {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.POSTCODE')
          }
        }
      ],
      empty: {
        text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_SUPPLIERS_FOUND')
      },
      pagination: {
        enabled: false
      },
      rows: {
        highlight: {
          enabled: true
        },
        select: {
          enabled: true
        }
      },
      sorting: {
        enabled: false
      }
    };
  }

  onRowClick (): void {
    this.selectedItems = this.vendors.filter(row => row.selected);
  }

  onRowDoubleClick (event: TableRowEvent): void {
    this.selectedItems = [event.row];
    this.confirm();
  }

  confirm (): void {
    this.vendorFactoryService.saveLinkedVendor(this.company, this.selectedItems[0]).then(() => {
      this.modal.close();
    }).catch(err => {
      this.messagesService.error(err);
    });
  }

  filter (): void {
    this.vendorFactoryService.searchVendorsInCompany(this.company, this.filters).then(vendors => {
      this.vendors = vendors;
      this.selectedItems = this.vendors.filter(row => row.selected);
    }).catch(err => {
      this.messagesService.error(err);
    });
  }
}
